import React, { useState } from 'react'
import { Card, Row, Col, Modal} from 'react-bootstrap'
import { AlternateEmailOutlined, CallEndOutlined } from '@material-ui/icons'

const TechnicalCall = ({ providersList }) => {
	const logMeinInfo = () => {
		return (<>
			<Row className="mb-4">
				<Col md="12"><span className="font-weight-bold fs-5">Onboarding Implantação:</span></Col>
				<Col><span>O onboarding na implantação dos projetos é realizado através da ferramenta GUIDE CX, o cliente final é contatado pela área de projetos LogMeIn para ter acesso a esse sistema. 
					Todo contato na etapa de implantação é realizado através da ferramenta Guide CX da LogMeIn.</span></Col>
			</Row>
			<Row className="mb-4">
				<Col md="12">
					<span className="font-weight-bold">E-mail de contato com a área de projetos:</span>
				</Col>
				<Col>
					<span className="h5"><AlternateEmailOutlined /> <a href="mailto:projetos@logmein.com">projetos@logmein.com</a></span>
				</Col>
			</Row>
			<Row className="mb-2">
				<Col md="12" className="mb-2">
					<span className="font-weight-bold">Suporte técnico – PABX em Nuvem GoToConnect</span>
				</Col>
				<Col md="12">
					<span className="font-weight-bold">Contato:</span>
				</Col>
				<Col>
					<span className="h5"><CallEndOutlined /> 0800-878-3155</span>
				</Col>
			</Row>
			<Row>
				<Col md="12">
					<span className="font-weight-bold">E-Mails:</span>
				</Col>
				<Col md="12">
					<span className="h5">
						<AlternateEmailOutlined /> <a href="mailto:jive-supportejive@logmein.com">jive-supportejive@logmein.com</a>
					</span>
				</Col>
				<Col md="12">
					<span className="h5">
						<AlternateEmailOutlined /> <a href="mailto:brasilgotoconnectsuporte@logmein.com">brasilgotoconnectsuporte@logmein.com</a>
					</span>
				</Col>
			</Row>
		</>)
	}

	const net2PhoneInfo = () => {
		return (<>
			<Row className="mb-4">
				<Col md="12"><span className="font-weight-bold">Suporte Técnico:</span></Col>
				<Col md="12"><span className="h5"><CallEndOutlined /> 0800 580 2626</span></Col>
			</Row>
			<Row className="mb-4">
				<Col md="12"><span className="font-weight-bold">SAC:</span></Col>
				<Col md="12"><span className="h5"><CallEndOutlined /> 10326</span></Col>
			</Row>
			<Row className="mb-4">
				<Col md="12"><span className="font-weight-bold">E-mail:</span></Col>
				<Col md="12"><span className="h5"><AlternateEmailOutlined /> <a href="mailto:suporte@net2phone.com">suporte@net2phone.com</a></span></Col>
			</Row>
			<Row className="mb-4">
				<Col md="12"><span className="font-weight-bold">Suporta a Portabilidade:</span></Col>
				<Col md="12"><span className="h5"><AlternateEmailOutlined /> <a href="mailto:portabilidade@net2phone.com">portabilidade@net2phone.com</a></span></Col>
			</Row>
		</>)
	}

	const equinixInfo = () => {
		return (<>
			<Row className="mb-4">
				<Col md="12"><span className="font-weight-bold">Suporte Técnico:</span></Col>
				<Col md="12"><span className="h5"><CallEndOutlined /> 0800 892 5065 / 11 3958 0325</span></Col>
			</Row>
			<Row className="mb-4">
				<Col md="12"><span className="font-weight-bold">E-Mail:</span></Col>
				<Col md="12"><span className="h5"><AlternateEmailOutlined /> <a href="mailto:support@equinix.com">support@equinix.com</a></span></Col>
			</Row>
		</>)
	}

	const cypressInfo = () => {
		return (
			<Row className="mb-4">
				<Col md="12"><span className="font-weight-bold">Suporte Técnico:</span></Col>
				<Col md="12"><span className="h5"><CallEndOutlined /> 0800 726 8926</span></Col>
			</Row>
		)
	}

	const providers = [
		{
			id: 1,
			modal_size: "lg",
			info: logMeinInfo()
		},
		{
			id: 2,
			modal_size: "",
			info: net2PhoneInfo()
		},
		{
			id: 3,
			modal_size: "",
			info: equinixInfo()
		},
		{
			id: 4,
			modal_size: "",
			info: cypressInfo()
		}
	];

	providersList.forEach((item) => {
		providers.filter(p => p.id == item.id)[0]['name'] = item.name;
		providers.filter(p => p.id == item.id)[0]['logo'] = item.url_image_logo;
	})

	const [data, setData] = useState({})
	const [showModal, setShowModal] = useState(false);

	return (<>
		<Row className="mt-4">
			<Col md="12">
				<p style={{ fontStyle: "italic" }}>
					“Caro Parceiro, o suporte técnico aos clientes finais é prestado diretamente pelo Provedor de Serviços. 
					Abaixo você poderá selecionar o Provedor de Serviços para obter o número de contato direto com o provedor para o devido atendimento”
				Em caso de dúvidas por favor entre em contato com <a href="mailto:contatomasteragent@scansource.com">contatomasteragent@scansource.com</a></p>
			</Col>
		</Row>
		<Row className="mt-4">
			{providers.map((p, i) => (
				<Col key={i} md="3" className="pb-3" style={{ height: '220px' }}>
					<Card className="h-100" style={{ cursor: 'pointer' }}
						onClick={async () => {
							await Promise.resolve().then(() => setData(p))
							setShowModal(true)
						}}
					>
						<Card.Body className="h-100 shadow rounded">
							<Row className="h-100">
								<Col className="d-flex align-items-center justify-content-center">
									<img className="center" src={`${p.logo}`}  className="w-75" />
								</Col>
							</Row>
						</Card.Body>
					</Card>
				</Col>
			))}
		</Row>		
		<Modal size={data.modal_size} show={showModal} centered onHide={() => setShowModal(false)}>
			<Modal.Header closeButton>
				<Modal.Title>
					<span>{data.name}</span>
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				{data.info ? data.info : null}
			</Modal.Body>
		</Modal>
	</>)
}

export default TechnicalCall;